import React from 'react'
import { WindowContainer } from './Trade.style'
import Header from './components/Header/Header'
import Body from './components/Body/Body'
import useTradeMessageHandler from './hook/useTradeMessageHandler'

const Trade = () => {
  const { data } = useTradeMessageHandler()
  return (
    <WindowContainer>
      <Header title={data.title} />
      {Object.keys(data).length && <Body data={data} />}
    </WindowContainer>
  )
}

export default Trade
